module.exports = __webpack_public_path__ + "static/media/mala.cc9838e5.svg";